import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import { Provider, Response } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  private api: string = CONTROLLERS.TENANTS.PROVIDER;
  constructor(private apiService: ApiService) {}

  getProvidersDropdownByPracticeId(
    practiceId: number
  ): Observable<Response<Provider[]>> {
    return this.apiService.getById(
      practiceId.toString(),
      `${this.api}/${ENDPOINTS.TENANTS.PROVIDER.DROPDOWN_BY_PRACTICE}`
    );
  }
}
